import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Account, ProjectType, PropertyType, ProjectStage } from 'app/core/models/account.types';
import { FileResource } from 'app/shared/modules/folders/folders.types';
import { AccountFoldersService } from 'app/modules/folders/folders.service';
import { AccountService } from 'app/core/services/account.service';

@Component({
  selector: 'project-generate-underwriting-model',
  templateUrl: './project-generate-underwriting-model.component.html',
  styleUrls: ['./project-generate-underwriting-model.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectGenerateUnderwritingModelComponent extends OnDestroyMixin implements OnInit {
  projectForm: UntypedFormGroup;
  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  public uploadedFile: any;
  options: [];
  fileResources: FileResource[];
  filteredFileResources: FileResource[];
  public fileResourceFilterCtrl: UntypedFormControl = new UntypedFormControl();
  account: Account;
  header: string = 'Generate Underwriting Model';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectGenerateUnderwritingModelComponent>,
    private _formBuilder: UntypedFormBuilder,
    private accountFoldersService: AccountFoldersService,
    private _accountService: AccountService,
  ) {
    super();
    this._accountService.currentAccount.pipe(untilComponentDestroyed(this)).subscribe((accountData) => {
      this.account = accountData;
      this.accountFoldersService.accountId = accountData.id;
    });
  }

  ngOnInit(): void {
    this.projectForm = this._formBuilder.group({
      file_resource_id: ['', [Validators.required]],
    });

    this.header = this.data.header;

    this.accountFoldersService
      .getAllFiles()
      .pipe(untilComponentDestroyed(this))
      .subscribe((fileResources) => {
        this.fileResources = fileResources;

        this.fileResources = this.fileResources.filter(
          (option) =>
            option.name.toLowerCase().indexOf('.xlsxb') > -1 ||
            option.name.toLowerCase().indexOf('.xlsx') > -1 ||
            option.name.toLowerCase().indexOf('.xls') > -1 ||
            option.name.toLowerCase().indexOf('.xlsm') > -1,
        );
        this.filteredFileResources = this.fileResources;
      });

    this.fileResourceFilterCtrl.valueChanges.pipe(untilComponentDestroyed(this)).subscribe(() => {
      this.filterFileResources();
    });
  }

  onFileChanged($event) {
    const file = $event.target.files[0];
    this.uploadedFile = file;
  }

  filterFileResources() {
    if (!this.fileResources) {
      return;
    }
    const search = this.fileResourceFilterCtrl.value?.toLowerCase();
    this.filteredFileResources = this.fileResources.filter((option) => option.name.toLowerCase().indexOf(search) > -1);
  }

  discard(): void {
    this.matDialogRef.close();
  }

  save(): void {
    this.projectForm.disable();

    const fileResourceId = this.projectForm.get('file_resource_id').value;
    const index = this.fileResources.findIndex((item) => item.id === fileResourceId);
    const fileResource = this.fileResources[index];
    let format = 'docx';
    if (fileResource.name.includes('pdf')) {
      format = 'pdf';
    }
    this.matDialogRef.close({
      file_resource_id: fileResourceId,
      format: format,
      action: 'generate',
      file_name: fileResource.name,
    });
  }
}
